import React from "react";
import {
  Chip,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { getDisplayEventName } from "../utils/schema.util";

interface Props {
  selectedCategory: "wisr" | "appCoordinator";
  paginatedEvents: string[];
  filteredEventsCount: number;
  searchQuery: string;
  page: number;
  rowsPerPage: number;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPageChange: (event: unknown, newPage: number) => void;
  onSelectEvent: (eventName: string) => void;
}

export const EventsTable: React.FC<Props> = ({
  selectedCategory,
  paginatedEvents,
  filteredEventsCount,
  searchQuery,
  page,
  rowsPerPage,
  onSearchChange,
  onPageChange,
  onSelectEvent,
}) => (
  <>
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 2,
        backgroundColor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <TextField
        fullWidth
        placeholder="Search events..."
        variant="outlined"
        value={searchQuery}
        onChange={onSearchChange}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </Paper>

    <Paper elevation={0} sx={{ border: "1px solid", borderColor: "divider" }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "action.hover" }}>
              <TableCell sx={{ fontWeight: 600 }}>Event Name</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
              <TableCell align="right" sx={{ fontWeight: 600 }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedEvents.length > 0 ? (
              paginatedEvents.map((eventName) => (
                <TableRow
                  key={eventName}
                  hover
                  sx={{ cursor: "pointer", "&:hover": { backgroundColor: "action.hover" } }}
                  onClick={() => onSelectEvent(eventName)}
                >
                  <TableCell>{getDisplayEventName(eventName)}</TableCell>
                  <TableCell>
                    <Chip
                      label={selectedCategory === "wisr" ? "Wisr" : "App Coordinator"}
                      size="small"
                      color={selectedCategory === "wisr" ? "primary" : "secondary"}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2" sx={{ color: "primary.main", fontWeight: 500 }}>
                      Configure →
                    </Typography>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ py: 8 }}>
                  <Typography color="text.secondary">
                    No events found matching "{searchQuery}"
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={filteredEventsCount}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[20]}
      />
    </Paper>
  </>
);
